import { render, staticRenderFns } from "./Create_template_backup.vue?vue&type=template&id=1c871ada&scoped=true"
import script from "./Create_template_backup.vue?vue&type=script&lang=js"
export * from "./Create_template_backup.vue?vue&type=script&lang=js"
import style0 from "./Create_template_backup.vue?vue&type=style&index=0&id=1c871ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c871ada",
  null
  
)

export default component.exports